import { useJourneyStaticDetails, useJourneyDynamicDetails } from "../context";
import { getExtrasTotal } from "../components/TripMoneyBreakdown/utils";
import { getValues } from "src/utility/objects";
import { useSelector } from "react-redux";
import { RootState } from "src/store";
import { PassengerInputType } from "src/Modules/Flights/constants/JourneyDetails";
import { FlightDetailsHookReturnType } from "src/store/slices/flights/Flights";

export function computeTotalFare(
  data: FlightDetailsHookReturnType["data"],
  passengers: PassengerInputType,
  redeemFactor: number,
  isFetching: boolean,
) {
  const extraMoney = getExtrasTotal(passengers);
  const { totalFare, pointsFactor } = getValues(data ?? {}, {
    totalFare: { path: ["fare", "publishedFare"], default: 0 },
    pointsFactor: { path: ["fare", "pointsFactor"], default: redeemFactor },
  });

  const totalPrice = isFetching ? 0 : extraMoney + totalFare;

  return { totalPrice, pointsFactor, isFetching };
}

export default function useTotalFare() {
  const { journeyDetails } = useJourneyStaticDetails();
  const { passengersState } = useJourneyDynamicDetails();
  const redeemFactor = useSelector((state: RootState) => state.client.userDetails.redeemFactor);
  const { data, isFetching } = journeyDetails;
  const [passengers] = passengersState;

  return computeTotalFare(data, passengers, redeemFactor, isFetching);
}
